import Formulaire from "../Components/Formulaire.js"

const Devis = () => <Formulaire />

export default Devis
